import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-booking-confirmation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="container mx-auto px-4 py-16">
      <div class="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-10 text-center">
        <div class="mx-auto mb-6 h-14 w-14 rounded-full bg-green-100 flex items-center justify-center">
          <span class="text-2xl">✅</span>
        </div>
        <h1 class="text-3xl font-bold mb-4 text-brand-primary">Vielen Dank für Ihre Anfrage!</h1>
        <p class="text-gray-700 mb-6">
          Wir haben Ihre Buchungsanfrage erhalten. Sie bekommen in Kürze eine E-Mail mit Ihrem Magic Link,
          um den Status einzusehen und Details zu verwalten.
        </p>
        <div class="space-y-2 text-sm text-gray-600 mb-8">
          <p>Prüfen Sie bitte auch Ihren Spam-Ordner.</p>
          <p>Bei Rückfragen erreichen Sie uns unter <a class="text-brand-primary font-semibold" href="mailto:info@videowand-leipzig.de">info@videowand-leipzig.de</a>.</p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3 justify-center">
          <a routerLink="/booking" class="px-4 py-2 rounded-lg border border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white transition">Weitere Anfrage stellen</a>
          <a routerLink="/" class="px-4 py-2 rounded-lg bg-brand-primary text-white hover:opacity-90 transition">Zur Startseite</a>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class BookingConfirmationComponent {}
